<template>
  <div>
    <api-info-block title="错误码">
      <div>
        <div class="api-content__info">
          <h4 class="api-content__subTitle">公共错误码</h4>
          <Table :columns="columns1" width="900" :data="publicError"></Table>
        </div>
        <div class="api-content__info">
          <h4 class="api-content__subTitle">业务错误码</h4>
          <Table :columns="columns1" width="900" :data="domainError"></Table>
        </div>
      </div>
    </api-info-block>
  </div>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import ApiInfoBlock from "./api-info-block.vue";

export default {
  data() {
    return {
      columns1: [
        {
          title: "错误码",
          key: "errorCode"
        },
        { title: "错误描述", key: "errorRemark" },
        { title: "解决方案", key: "errorAcmark" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      publicError: "apiDoc/publicError",
      domainError: "apiDoc/domainError"
    })
  },

  components: {
    ApiInfoBlock
  }
};
</script>
